import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import moment from "moment";
import DatePicker from "react-datepicker";
import { Card, Modal } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { setNewTariff, uploadNewTariff } from './dispatch';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSubCategory, fetchSupplierCategory, fetchUnitCategory } from '../dashboard/dispatch';
import { setCategoryData } from '../../utils/utility';
function MasterValue(props) {
  console.log(props)
  // const { data } = useSelector(state => state.loginReducer);
  const data =  JSON.parse(localStorage.getItem("USER_DETAILS")); 
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [newTariffFormData, setnewTariffFormData] = useState({});
  const [TariffValidFrom, setTariffValidFrom] = useState(new Date());
  const [TariffDueDate, setTariffDueDate] = useState(new Date());
  const [errorsMasterValue, setErrorsMasterValue] = useState({});
  const { masterValueData, uploadDataNewTariff } = useSelector(state => state.newTariffReducer);
  const { dashboardData, subCategoryData, supplierTypeData, FCUnitData, editsearchData, allDropDownData } = useSelector(state => state.dashboardReducer);
  useEffect(() => {
    console.log(allDropDownData)
    if (masterValueData) {
      setnewTariffFormData(masterValueData)
    } else {
      setnewTariffFormData(editsearchData?.data?.masterValueData)
    }
    console.log(masterValueData)
    dispatch(fetchUnitCategory(data))
  }, [masterValueData]);
  const dispatch = useDispatch();
  const handleClose = () => {
    setShow(false);
    setOpen(true)
  };
  const handleShow = () => {
    setShow(true);
  };
  const handleChangeDate = (date, event) => {
    // setDate(date);
    console.log(moment);
    setOpen(true)
  };
  const handleClick = () => {
    // props.onClick
    console.log(props.onClick)
  }
  const handleChange = (event, param) => {
    let name = event?.target?.name;
    let value = event?.target?.value;
    if (param == 'TariffValidFrom' ||
      param == 'TariffValidTo') {
      name = param;
      value = moment(event).format("YYYY-MM-DD").toString();
    }

    setnewTariffFormData(values => ({ ...values, [name]: value }))
    console.log(newTariffFormData)
  }
  const validateForm = () => {
    const newErrors = {};
    if (!newTariffFormData?.TariffName) newErrors.TariffName = 'Tariff Name is required';
    if (!newTariffFormData?.TariffDescription) newErrors.TariffDescription = 'Tariff Description is required';
    if (!newTariffFormData?.TariffServiceCategory) newErrors.TariffServiceCategory = 'Tariff Service Category is required';
    if (!newTariffFormData?.TariffServiceTypeCategory) newErrors.TariffServiceTypeCategory = 'Tariff Service Type Category is required';
    if (!newTariffFormData?.TariffSubCategoryCategory) newErrors.TariffSubCategoryCategory = 'Tariff Sub Category Category is required';
    if (!newTariffFormData?.TariffFixedUnit) newErrors.TariffFixedUnit = 'Tariff Fixed Unit is required';
    if (!newTariffFormData?.TariffFixedCharges) newErrors.TariffFixedCharges = 'Tariff Fixed Charges is required';
    if (!newTariffFormData?.TariffValidTo) newErrors.TariffValidTo = 'Tariff Valid To is required';
    if (!newTariffFormData?.TariffValidFrom) newErrors.TariffValidFrom = 'Tariff  Valid From is required';
    return newErrors;
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const formErrors = validateForm();

    if (Object.keys(formErrors).length > 0) {
      setErrorsMasterValue(formErrors);
    } else {
      setErrorsMasterValue({});
      props.onClick("#ElectricityValue")
      dispatch(setNewTariff(newTariffFormData))
    }
  };
  return (
    <Form onSubmit={handleSubmit} >
      {
        (data?.pDATASET[0]?.STATE_NAME || data?.pDATASET[0]?.CIRCLE_NAME) ?
          <Card style={{ borderWidth: 0, height: '60px', width: '100%', backgroundColor: '#FFF6D6', borderRadius: '0px' }}>
            <Container style={{ paddingTop: '10px', }}>
              <Row>
                <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>State</Col>
                <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>Distict</Col>
                {uploadDataNewTariff?.PTARIFFID ? <Col sm={2} style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>Tariff ID</Col> : null}
              </Row>
              <Row>
                <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }}>{data?.pDATASET[0]?.STATE_NAME}</Col>
                <Col sm={2} style={{ fontFamily: "Roboto-Regular", fontSize: '15px' }}>{data?.pDATASET[0]?.CIRCLE_NAME}</Col>
                <Col sm={2} style={{ fontFamily: "Roboto-Regular ", fontSize: '15px' }}>{uploadDataNewTariff?.PTARIFFID}</Col>
              </Row> </Container> </Card> : null
      }

      <Row className="mb-3" >
        <Form.Group as={Col} sm={3} controlId="Tariffname" style={{ marginTop: '20px' }}>
          <Form.Label style={{ fontFamily: "Roboto-Light", fontSize: '13px' }}>* Tariff name </Form.Label>
          <Form.Control placeholder="Tariff name"
            value={newTariffFormData?.TariffName}
            name="TariffName"
            onChange={handleChange}
            isInvalid={!!errorsMasterValue.TariffName} />
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue?.TariffName}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
      <Row className="mb-3" >
        <Form.Group as={Col} sm={3} controlId="Discription" >
          <Form.Label>* Discription</Form.Label>
          <Form.Control placeholder="Discription"
            value={newTariffFormData?.TariffDescription}
            name="TariffDescription"
            onChange={handleChange}
            isInvalid={!!errorsMasterValue.TariffDescription} />
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffDescription}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="ServiceCategory">
          <Form.Label>* Service Category</Form.Label>
          <Form.Select defaultValue="Choose..."
            name="TariffServiceCategory"
            value={newTariffFormData?.TariffServiceCategory}
            onChange={(e) => { setCategoryData(e?.target?.value); handleChange(e); dispatch(fetchSubCategory(data, e?.target?.value)); dispatch(fetchSupplierCategory(data, e?.target?.value)) }}
            isInvalid={!!errorsMasterValue.TariffServiceCategory}>
            <option value="">Please select</option>
            {
              dashboardData?.pDATASET.map((item) => {
                return <option value={item.CATEGORY_ID}>{item.CATEGORY_NAME}</option>
              })
            }
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffServiceCategory}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="SubCategory">
          <Form.Label>* Sub Category</Form.Label>
          <Form.Select defaultValue="Choose..."
            name="TariffSubCategoryCategory"
            onChange={(e) => { handleChange(e); dispatch(fetchSupplierCategory(data, e?.target?.value)) }}
            value={newTariffFormData?.TariffSubCategoryCategory}
            isInvalid={!!errorsMasterValue.TariffSubCategoryCategory} >
            <option value="">Please select</option>
            {
              subCategoryData?.pDATASET.map((item) => {
                return <option value={item.SUBCATEGORY_ID}>{item.SUBCATEGORY_NAME}</option>
              })
            }
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffSubCategoryCategory}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="ServiceType">
          <Form.Label>* Supplier Type</Form.Label>
          <Form.Select defaultValue="Choose..."
            name="TariffServiceTypeCategory"
            onChange={handleChange}
            value={newTariffFormData?.TariffServiceTypeCategory}
            isInvalid={!!errorsMasterValue.TariffServiceTypeCategory}>
            <option value="">Please select</option>
            {
              supplierTypeData?.pDATASET.map((item) => {
                return <option value={item.SUPPLIERTYPE_ID}>{item.SUPPLIERTYPE_NAME}</option>
              })
            }
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffServiceTypeCategory}
          </Form.Control.Feedback>
        </Form.Group>

      </Row>
      <Row className="mb-3">

        <Form.Group as={Col} sm={3} controlId="TariffCycle">
          <Form.Label>*  Tariff Cycle</Form.Label>
          <Form.Select defaultValue="Choose..."
            name="TariffCycle"
            onChange={handleChange}
            value={newTariffFormData?.TariffCycle}
            isInvalid={!!errorsMasterValue.TariffCycle}>
            <option value="">Please select</option>
            {
              allDropDownData?.pDATASET.map((item) => {
                if (item.TYPE == 'TCUNIT')
                  return <option value={item.ID}>{item.NAME}</option>
              })
            }
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffCycle}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="ValidFrom">
          <Form.Label>* Valid From</Form.Label>
          <Modal.Body isInvalid={!!errorsMasterValue.TariffValidFrom}>
            <DatePicker
              // minDate={moment().toDate()}
              dateFormat="yyyy/MM/dd"
              style={{ borderWidth: 10, width: '50%' }}
              selected={moment(newTariffFormData?.TariffValidFrom).format("YYYY-MM-DD")}
              onChange={(date) => handleChange(date, 'TariffValidFrom')}
              icon={<img src={require('../../assets/calender.png')} style={{ paddingLeft: '10px', right: 5, width: 20, height: 20 }} onClick={() => setOpen(!open)} />}
              showIcon
            />
          </Modal.Body>
          <div style={{ paddingTop: '5px', color: '#dc3545', fontSize: '.875em' }}>
            {errorsMasterValue.TariffValidFrom}
          </div>

        </Form.Group>
        <Form.Group as={Col} controlId="ValidTo">
          <Form.Label>* Valid To</Form.Label>
          <Modal.Body>
            <DatePicker

              //  minDate={moment(newTariffFormData?.TariffValidFrom).format("YYYY-MM-DD").add(1, 'd ')}
              // minDate={moment(newTariffFormData?.TariffValidFrom).format("YYYY-MM-DD")}
              dateFormat="yyyy/MM/dd"
              selected={moment(newTariffFormData?.TariffValidTo).format("YYYY-MM-DD")}
              onChange={(date) => handleChange(date, 'TariffValidTo')}
              icon={<img src={require('../../assets/calender.png')} style={{ paddingLeft: '10px', right: 5, width: 20, height: 20 }} onClick={() => setOpen(!open)} />}
              showIcon
              isInvalid={!!errorsMasterValue.TariffValidTo}
            />
          </Modal.Body>
          <div style={{ paddingTop: '5px', color: '#dc3545', fontSize: '.875em' }}>
            {errorsMasterValue.TariffValidTo}
          </div>
        </Form.Group>

      </Row>
      <Row className="mb-3">

      </Row>
      <Row className="mb-3">
        <Form.Group as={Col} sm={3} controlId="FixedCharges">
          <Form.Label>* Fixed Charges</Form.Label>
          <Form.Control placeholder="Fixed Charges"
            onKeyPress={(event) => {
              if (!/[0-9.]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            value={newTariffFormData?.TariffFixedCharges}
            name="TariffFixedCharges"
            onChange={handleChange}
            onPaste={(e) => {
              e.preventDefault()
              return false;
            }}
            isInvalid={!!errorsMasterValue.TariffFixedCharges} />
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffFixedCharges}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="TariffFixedUnit">
          <Form.Label>* FC Unit</Form.Label>
          <Form.Select defaultValue="Choose..."
            name="TariffFixedUnit"
            onChange={(e) => { handleChange(e); dispatch(fetchSupplierCategory(data, e?.target?.value)) }}
            value={newTariffFormData?.TariffFixedUnit}
            isInvalid={!!errorsMasterValue.TariffFixedUnit} >
            <option value="">Please select</option>
            {
              allDropDownData?.pDATASET.map((item) => {
                if (item.TYPE == 'FCUNIT')
                  return <option value={item.ID}>{item.NAME}</option>
              })
            }
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffFixedUnit}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="FCSubsidy">
          <Form.Label>FC - Subsidy</Form.Label>
          <Form.Control placeholder="FC Subsidy"
            onKeyPress={(event) => {
              if (!/[0-9.]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onPaste={(e) => {
              e.preventDefault()
              return false;
            }}
            value={newTariffFormData?.TariffFixedSubsidy}
            name="TariffFixedSubsidy"
            onChange={handleChange}
            isInvalid={!!errorsMasterValue.TariffFixedSubsidy} />
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffFixedSubsidy}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="applicablecharges">
          <Form.Label>Applicable Charges</Form.Label>
          <Form.Control placeholder="Applicable Charges"
            readOnly

            value={(newTariffFormData?.TariffFixedCharges && newTariffFormData?.TariffFixedSubsidy) ? (newTariffFormData?.TariffFixedCharges) - (newTariffFormData?.TariffFixedSubsidy) : null}
            name="TariffFixedSubsidy"
            onChange={handleChange}
            isInvalid={!!errorsMasterValue.TariffFixedSubsidy} />
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffFixedSubsidy}
          </Form.Control.Feedback>
        </Form.Group>

      </Row>

      <Row className="mb-3">

        <Form.Group as={Col} sm={3} controlId="MinimumCharges">
          <Form.Label>Minimum Charges</Form.Label>
          <Form.Control placeholder="Minimum Charges"
            onKeyPress={(event) => {
              if (!/[0-9.]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onPaste={(e) => {
              e.preventDefault()
              return false;
            }}
            value={newTariffFormData?.TariffFixedMinimumCharges}
            name="TariffFixedMinimumCharges"
            onChange={handleChange}
            isInvalid={!!errorsMasterValue.TariffFixedMinimumCharges} />
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffFixedMinimumCharges}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group as={Col} sm={3} controlId="MaximumCharges">
          <Form.Label>Maximum Charges</Form.Label>
          <Form.Control placeholder="Maximum Charges"
            onKeyPress={(event) => {
              if (!/[0-9.]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onPaste={(e) => {
              e.preventDefault()
              return false;
            }}
            value={newTariffFormData?.TariffFixedMaximumCharges}
            name="TariffFixedMaximumCharges"
            onChange={handleChange}
            isInvalid={!!errorsMasterValue.TariffFixedMaximumCharges} />
          <Form.Control.Feedback type="invalid">
            {errorsMasterValue.TariffFixedMaximumCharges}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <div style={{ marginTop: 40, marginLeft: '10px' }}>
        <Button variant="primary" type="submit">
          Cancel
        </Button>

        <Button variant="primary" type="submit" style={{ marginLeft: 15 }}
          onClick={() => {
            let masterValue = { masterValueData }
            console.log(masterValue)
            setnewTariffFormData(values => ({ ...values, 'CircleId': data?.pDATASET[0]?.CIRCLE_ID, 'StateId': data?.pDATASET[0]?.STATE_ID, 'TariffId': uploadDataNewTariff?.PTARIFFID ? uploadDataNewTariff?.PTARIFFID : '', "Status": "Draft", "UserName": data?.pDATASET[0]?.USERNAME }))
            // dispatch(uploadNewTariff(masterValue, data, uploadDataNewTariff?.PTARIFFID))
          }}
        >
          Save & continue
        </Button>
      </div>
    </Form>
  );
}

export default MasterValue;